import { FC, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useSelectIsAdmin } from '../../state/selectors'
import { useIsUserSet } from '../../state/selectors'
import { LoadingSpinner } from '../LoadingSpinner'
import { theme } from '../../theme/theme'

export const AdminViewGuard: FC = () => {
  const navigate = useNavigate()
  const isAdmin = useSelectIsAdmin()
  const isUserFetched = useIsUserSet()

  useEffect(() => {
    if (isUserFetched && !isAdmin) {
      navigate('/portal')
    }
  }, [isAdmin, isUserFetched, navigate])

  if (!isUserFetched) {
    return <LoadingSpinner size={75} color={theme.color.plum} />
  }

  return isAdmin ? <Outlet /> : null
}
